import { z } from 'zod'

export const brokerPaymentSettingsResponseSchema = z.object({
  dividendCategoryId: z.string().nullable(),
  couponCategoryId: z.string().nullable(),
  // per-account income-description templates ({ticker}/{name} placeholders); null means "use default"
  dividendDescriptionTemplate: z.string().nullable(),
  couponDescriptionTemplate: z.string().nullable(),
})

export type BrokerPaymentSettingsResponseDto = z.infer<typeof brokerPaymentSettingsResponseSchema>
